import React from 'react';
import { Box, Text, LinkButton } from 'tailwind-react-ui';
import motelsParticipating from '../assets/data/participating-motels.json';


const baseSourceUrl = 'https://storage.googleapis.com/assets-sixtynite-com/chelas-gratis/moteles/';

const MotelsParticipatingSection = () =>{

    const [hidden, setHidden] = React.useState(true /*false*/);
    var motelLimit = hidden ? motelsParticipating.length : 20;

    const motelsDesktop = motelsParticipating.slice(0, motelLimit).map((motel) =>{
        return(
            <div key= {motel.id} className="inline-flex">
                <img className="mx-10 my-4 w-20 h-20" src={baseSourceUrl+motel.src+motel.ext} alt={motel.src}/>
            </div>
        )
    })

    const motelsMobile = motelsParticipating.map((motel) =>{
        return(
            <div key= {motel.id} className="inline-flex">
                <img className="m-4 w-20 h-20" src={baseSourceUrl+motel.src+motel.ext} alt={motel.src}/>
            </div>
        )
    })

    return(
        <Box id="moteles-participantes" bg={'very-light-gray'}>
            <Box className="landing-container pb-0 md:pb-16" text={['center', 'dark-gray']}>
                <Text is="h3" className="quicksand-bold tracking-wide" size="4xl" m={{b: 6}}>
                    Moteles participantes
                </Text>
                <Text is="p" className="quicksand-regular tracking-wide" size="2xl" m={{b: 6}}>
                    Estos son algunos Moteles participantes en la promoción.
                </Text>
                {
                    !hidden ? 
                    <>
                    <LinkButton 
                    style={{borderWidth: '0'}} 
                    className="quicksand-regular hidden md:block text-xl text-yellow m-auto"
                    onClick={() => setHidden(true)}>
                        Ver todos &gt;
                    </LinkButton>
                    </> : null
                }  
                <Box className="hidden md:block">
                    {motelsDesktop}
                </Box>
            </Box>
            <Box className="scrolling-wrapper whitespace-no-wrap overflow-x-auto pb-16 md:pb-0 md:hidden">
                {motelsMobile}
            </Box>
        </Box>
    );
}

export default MotelsParticipatingSection;